module.exports = __webpack_public_path__ + "static/media/antoine.ec5f0192.jpg";